import { Box, Flex, Heading, Spacer } from "@chakra-ui/react"
import * as React from "react"
import { Route, Link as RouterLink, Switch } from "react-router-dom"
import { useLocalStorage } from "react-use"

import { ConnectBtn } from "./component/ConnectBtn"
import { TabRewards } from "./component/Icons"
import { SwitchNetworkBtn } from "./component/SwitchNetworkBtn"
import { RouteName } from "./constant"
import { Account, CONNECTOR_ID } from "./module/account"

const PageHome = React.lazy(() => import("./page/Home/PageHome").then(module => ({ default: module.PageHome })))
const PageOnboarding = React.lazy(() =>
    import("./page/Onboarding").then(module => ({ default: module.PageOnboarding })),
)
const PageOnboardingProgram = React.lazy(() =>
    import("./page/PageOnboardingProgram").then(module => ({ default: module.PageOnboardingProgram })),
)
const PageSeedAllocation = React.lazy(() => import("./page/PageSeedAllocation"))
const PageGasRebate = React.lazy(() => import("./page/PageGasRebate"))
const PageTestnetCompetition = React.lazy(() => import("./page/PageTestnetCompetition"))
const PageLiquidityMiningList = React.lazy(() => import("./page/LiquidityMining/PageLiquidityMiningList"))
const PageLiquidityMiningPair = React.lazy(() => import("./page/LiquidityMining/PageLiquidityMiningPair"))

export const App = () => {
    const {
        account,
        isWrongNetwork,
        actions: { login },
    } = Account.useContainer()
    const [connectorId] = useLocalStorage(CONNECTOR_ID.name, CONNECTOR_ID.defaultValue)
    return (
        <Box pb="200px">
            <Flex p={[10, 65]}>
                <Box>
                    <RouterLink to="/">
                        <Flex align="center">
                            <TabRewards boxSize="32px" />
                            <Heading size="md" borderLeft="1px solid" pl="17px" ml="13px">
                                Perp Rewards Dashboard
                            </Heading>
                        </Flex>
                    </RouterLink>
                </Box>
                <Spacer />
                <Flex align="center" flexDir={["column", "row"]}>
                    {!!account && isWrongNetwork && (
                        <SwitchNetworkBtn
                            connectorId={connectorId || ""}
                            login={login}
                            mr="20px"
                            mb={["10px", "initial"]}
                        />
                    )}
                    <ConnectBtn />
                </Flex>
            </Flex>

            <Switch>
                <Route path={RouteName.ROOT} exact component={PageHome} />
                <Route path={RouteName.ONBOARDING} exact component={PageOnboarding} />
                <Route path={RouteName.GAS_REBATE} exact component={PageGasRebate} />
                <Route path={RouteName.TESTNET_COMPETITION} exact component={PageTestnetCompetition} />
                <Route path={RouteName.LIQUIDITY_MINING_LIST} exact component={PageLiquidityMiningList} />
                <Route path={RouteName.LIQUIDITY_MINING_PAIR} exact component={PageLiquidityMiningPair} />
                <Route path={RouteName.SEED_ALLOCATION} exact component={PageSeedAllocation} />
                <Route path={`${RouteName.ONBOARDING_PROGRAM}/:oauthTarget?`} exact component={PageOnboardingProgram} />
            </Switch>
        </Box>
    )
}
